<template>
  <div
    v-if="activediscounts"
    class="cart-discount-form"
  >
    <input
      v-model="code"
      :placeholder="$t('cart.promoCode')"
      @keyup.enter="addDiscount"
    >
    <div class="discount-button">
      <button
        class="btn"
        @click="addDiscount"
      >
        {{ $t('cart.applyDiscount') }}
      </button>
    </div>

    <p
      v-if="message != null"
      class="notice"
    >
      {{ message }}
      <span
        class="close"
        @click="message = null"
      />
    </p>
  </div>
</template>

<script>
import Api from './cart_api'

export default {

  props: ['activediscounts'],
  data() {
    return {
      code: null,
      message: null
    }
  },

  methods: {
    addDiscount() {
      Api.addDiscount(JSON.stringify({ discount_code: this.code })).then(response => {
        this.message = response.message
      })
    }
  }
}
</script>
